const platformLanguages = {
  languageArray: ['en', 'de']
};
export default platformLanguages;
